/**
 * Labstep
 *
 * @module core/Loadable
 * @desc Wrapper around react loadable
 */

import { LoaderTimeEnabled } from 'labstep-web/core/Loader/TimeEnabled';
import React from 'react';
import type { ILoadableProps } from './types';

export const Loadable: RFC<ILoadableProps> = ({
  loader,
  children,
}) => (
  <React.Suspense
    fallback={loader || <LoaderTimeEnabled children={() => null} />}
  >
    {children}
  </React.Suspense>
);
